import React, { useState, useEffect } from 'react';
import { message, Modal } from 'antd';
import { withTranslation } from 'react-i18next';
import {
  Container,
  SettingpageContainer,
  LoaderContainer,
  UserContainer,
  DetailWrapper,
  DetailHeadingCover,
  ContractsGrid,
  ContractsScrollContainer
} from './styles';
import Loader from '../../components/Loader';
import ContractCard from './ContractCard';
import ContractEditor from './ContractEditor';
import { getAllContracts, deleteContract } from '../../utils/services/contractsAPI';
import { BUSINESS_CONTRACTS as trans } from './translationValues';

const NAMESPACES = ['BUSINESS_CONTRACTS'];

const BusinessContracts = props => {
  const { t } = props;
  const [contracts, setContracts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [editingContractId, setEditingContractId] = useState(null);
  const [showEditor, setShowEditor] = useState(false);

  useEffect(() => {
    fetchContracts();
  }, []);

  const fetchContracts = async () => {
    setIsLoading(true);
    try {
      const response = await getAllContracts();
      if (response && response.statusCode === 6008) {
        setContracts(response.data || []);
      } else {
        message.error(t(trans.ERROR_LOADING_CONTRACTS.key, trans.ERROR_LOADING_CONTRACTS.value));
      }
    } catch (error) {
      console.error('Error fetching contracts:', error);
      message.error(t(trans.ERROR_LOADING_CONTRACTS.key, trans.ERROR_LOADING_CONTRACTS.value));
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingContractId(null);
    setShowEditor(true);
  };

  const handleEdit = (id) => {
    setEditingContractId(id);
    setShowEditor(true);
  };

  const handleEditorClose = () => {
    setShowEditor(false);
    setEditingContractId(null);
    fetchContracts(); // Refresh list
  };

  const handleDelete = (id) => {
    const contract = contracts.find(c => c.id === id);
    Modal.confirm({
      title: t(trans.CONFIRM_DELETE_TITLE.key, trans.CONFIRM_DELETE_TITLE.value),
      content: t(trans.CONFIRM_DELETE_MESSAGE.key, trans.CONFIRM_DELETE_MESSAGE.value),
      okText: t(trans.DELETE.key, trans.DELETE.value),
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          const response = await deleteContract(id);
          if (response && response.statusCode === 6010) {
            message.success(t(trans.CONTRACT_DELETED.key, trans.CONTRACT_DELETED.value));
            fetchContracts();
          } else {
            message.error(t(trans.ERROR_DELETING_CONTRACT.key, trans.ERROR_DELETING_CONTRACT.value));
          }
        } catch (error) {
          console.error('Error deleting contract:', error);
          message.error(t(trans.ERROR_DELETING_CONTRACT.key, trans.ERROR_DELETING_CONTRACT.value));
        }
      }
    });
  };

  if (isLoading) {
    return (
      <Container>
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      </Container>
    );
  }

  // Show editor if active
  if (showEditor) {
    return (
      <ContractEditor
        contractId={editingContractId}
        onClose={handleEditorClose}
        t={t}
      />
    );
  }

  // Show contracts list
  return (
    <Container>
      <UserContainer>
        <SettingpageContainer>
          <DetailWrapper>
            <DetailHeadingCover>
              <h5>{t(trans.BUSINESS_CONTRACTS_TITLE.key, trans.BUSINESS_CONTRACTS_TITLE.value)}</h5>
              <p>{t(trans.BUSINESS_CONTRACTS_DESCRIPTION.key, trans.BUSINESS_CONTRACTS_DESCRIPTION.value)}</p>
            </DetailHeadingCover>
            <ContractsScrollContainer>
              <ContractsGrid>
                <ContractCard
                  isCreateCard={true}
                  onCreate={handleCreate}
                  t={t}
                />
                {contracts.map(contract => (
                  <ContractCard
                    key={contract.id}
                    contract={contract}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    t={t}
                  />
                ))}
              </ContractsGrid>
            </ContractsScrollContainer>
          </DetailWrapper>
        </SettingpageContainer>
      </UserContainer>
    </Container>
  );
};

export default withTranslation(NAMESPACES)(BusinessContracts);

